import { l } from '@manychat/manyui'

import { BillingVersion } from 'common/billing/constants/AccountBillingInfo'
import { getBillingAPI } from 'common/billing/entities/billingVersions/selectors'
import { alert } from 'common/core'
import { createAsyncAction } from 'shared/lib/redux'

export const setOverageLimit = createAsyncAction<unknown, { overage_limit: number }>(
  'billing/setOverageLimit',
  async (payload, { getState }) => {
    const { overage_limit } = payload
    const billingV3API = getBillingAPI(getState(), BillingVersion.V3)
    const response = await billingV3API.setOverageLimit({
      body: {
        overage_limit,
      },
    })

    alert(l.translate('Overages limit updated successfully'), 'success')

    return response.data
  },
  {
    errorMarkupOptions: {
      scope: 'billing',
      section: 'subscription',
    },
  },
)
